
export default {
  name: 'AssignCustomersPrivacy',

  layout: 'terms',
}
